import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ViewSpaceExternalCollaboratorsDialogQuery, {
	type ViewSpaceExternalCollaboratorsDialogQuery$data,
	type ViewSpaceExternalCollaboratorsDialogQuery$variables,
} from './__generated__/ViewSpaceExternalCollaboratorsDialogQuery.graphql.ts';

export function preloadSpaceGuestList(spaceKey: string) {
	return query<
		ViewSpaceExternalCollaboratorsDialogQuery$data,
		ViewSpaceExternalCollaboratorsDialogQuery$variables
	>({
		query: ViewSpaceExternalCollaboratorsDialogQuery,
		variables: {
			spaceKey,
		},
	});
}
